// Generated by scripts/build.ts from svg/*.svg — do not edit.
import type { IconNode } from '../types';

export const iconNames = ["alert-triangle","archive","blade","check","chevron-down","chevron-left","chevron-right","chevron-up","copy","dice","edit","info","lock","map","menu","minus","more-horizontal","pin","plus","scroll","search","settings","shield","swords","target","trash","trophy","user","users","x"] as const;
export type BuiltInIconName = (typeof iconNames)[number];

export const builtInIcons: Record<BuiltInIconName, IconNode[]> = {
  "alert-triangle": [
    [
      "path",
      {
        "d": "M12 4l9 15.5H3L12 4zM12 10v4M12 17v.01"
      }
    ]
  ],
  "archive": [
    [
      "rect",
      {
        "x": "3.5",
        "y": "4.5",
        "width": "17",
        "height": "4",
        "rx": "1"
      }
    ],
    [
      "path",
      {
        "d": "M5 8.5V19h14V8.5M10 12h4"
      }
    ]
  ],
  "blade": [
    [
      "path",
      {
        "d": "M20 3l-9.5 9.5M20 3h-5M20 3v5M10.5 12.5l-2-2M6 15l3 3M4 20l3-3M8.5 10.5L5 14"
      }
    ]
  ],
  "check": [
    [
      "path",
      {
        "d": "M5 12.5l4.5 4.5L19 7"
      }
    ]
  ],
  "chevron-down": [
    [
      "path",
      {
        "d": "M6 9l6 6 6-6"
      }
    ]
  ],
  "chevron-left": [
    [
      "path",
      {
        "d": "M15 6l-6 6 6 6"
      }
    ]
  ],
  "chevron-right": [
    [
      "path",
      {
        "d": "M9 6l6 6-6 6"
      }
    ]
  ],
  "chevron-up": [
    [
      "path",
      {
        "d": "M6 15l6-6 6 6"
      }
    ]
  ],
  "copy": [
    [
      "rect",
      {
        "x": "8.5",
        "y": "8.5",
        "width": "11",
        "height": "11",
        "rx": "2"
      }
    ],
    [
      "path",
      {
        "d": "M15.5 8.5V6a1.5 1.5 0 00-1.5-1.5H6A1.5 1.5 0 004.5 6v8A1.5 1.5 0 006 15.5h2.5"
      }
    ]
  ],
  "dice": [
    [
      "rect",
      {
        "x": "4",
        "y": "4",
        "width": "16",
        "height": "16",
        "rx": "3"
      }
    ],
    [
      "circle",
      {
        "cx": "9",
        "cy": "9",
        "r": "0.75",
        "fill": "currentColor"
      }
    ],
    [
      "circle",
      {
        "cx": "15",
        "cy": "15",
        "r": "0.75",
        "fill": "currentColor"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "0.75",
        "fill": "currentColor"
      }
    ]
  ],
  "edit": [
    [
      "path",
      {
        "d": "M4 20h4.5L19 9.5a2.1 2.1 0 00-3-3L5.5 17v3zM14.5 8l3 3"
      }
    ]
  ],
  "info": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    ],
    [
      "path",
      {
        "d": "M12 11v5M12 8v.01"
      }
    ]
  ],
  "lock": [
    [
      "rect",
      {
        "x": "5",
        "y": "11",
        "width": "14",
        "height": "10",
        "rx": "2"
      }
    ],
    [
      "path",
      {
        "d": "M8 11V7a4 4 0 018 0v4"
      }
    ]
  ],
  "map": [
    [
      "path",
      {
        "d": "M3.5 6.5l5.5-2.5 6 2.5 5.5-2.5v13.5l-5.5 2.5-6-2.5-5.5 2.5V6.5zM9 4v13.5M15 6.5V20"
      }
    ]
  ],
  "menu": [
    [
      "path",
      {
        "d": "M4 7h16M4 12h16M4 17h16"
      }
    ]
  ],
  "minus": [
    [
      "path",
      {
        "d": "M5 12h14"
      }
    ]
  ],
  "more-horizontal": [
    [
      "circle",
      {
        "cx": "5.5",
        "cy": "12",
        "r": "1.25",
        "fill": "currentColor"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "1.25",
        "fill": "currentColor"
      }
    ],
    [
      "circle",
      {
        "cx": "18.5",
        "cy": "12",
        "r": "1.25",
        "fill": "currentColor"
      }
    ]
  ],
  "pin": [
    [
      "path",
      {
        "d": "M9 4h6l-1 5.5 3.5 3v1.5h-11V12.5l3.5-3L9 4zM12 14v6"
      }
    ]
  ],
  "plus": [
    [
      "path",
      {
        "d": "M12 5v14M5 12h14"
      }
    ]
  ],
  "scroll": [
    [
      "path",
      {
        "d": "M7 4h11a2 2 0 012 2v1.5h-4M7 4a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7.5M7 4a2 2 0 012 2v12M9 9h6M9 13h6"
      }
    ]
  ],
  "search": [
    [
      "circle",
      {
        "cx": "11",
        "cy": "11",
        "r": "6.5"
      }
    ],
    [
      "path",
      {
        "d": "M20 20l-4.4-4.4"
      }
    ]
  ],
  "settings": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "3"
      }
    ],
    [
      "path",
      {
        "d": "M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M5.3 18.7l2.1-2.1M16.6 7.4l2.1-2.1"
      }
    ]
  ],
  "shield": [
    [
      "path",
      {
        "d": "M12 3l7.5 3v5.5c0 4.6-3.1 8.3-7.5 9.5-4.4-1.2-7.5-4.9-7.5-9.5V6L12 3z"
      }
    ]
  ],
  "swords": [
    [
      "path",
      {
        "d": "M4 4l9 9M4 4v3.5M4 4h3.5M20 4l-9 9M20 4v3.5M20 4h-3.5M7.5 16.5l-3 3M16.5 16.5l3 3M6 13l5 5M18 13l-5 5"
      }
    ]
  ],
  "target": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "9"
      }
    ],
    [
      "circle",
      {
        "cx": "12",
        "cy": "12",
        "r": "4"
      }
    ],
    [
      "path",
      {
        "d": "M12 1v4M12 19v4M1 12h4M19 12h4"
      }
    ]
  ],
  "trash": [
    [
      "path",
      {
        "d": "M4.5 7h15M10 11v6M14 11v6M6.5 7l1 12.5h9l1-12.5M9.5 7V4.5h5V7"
      }
    ]
  ],
  "trophy": [
    [
      "path",
      {
        "d": "M8 4h8v5a4 4 0 01-8 0V4zM8 6H5v1.5A3.5 3.5 0 008.5 11M16 6h3v1.5a3.5 3.5 0 01-3.5 3.5M12 13v4M8.5 20.5h7M9.5 17h5v3.5h-5z"
      }
    ]
  ],
  "user": [
    [
      "circle",
      {
        "cx": "12",
        "cy": "8",
        "r": "4"
      }
    ],
    [
      "path",
      {
        "d": "M4 20.5c1.4-3.6 4.4-5.5 8-5.5s6.6 1.9 8 5.5"
      }
    ]
  ],
  "users": [
    [
      "circle",
      {
        "cx": "9",
        "cy": "8",
        "r": "3.5"
      }
    ],
    [
      "path",
      {
        "d": "M2.5 19.5c1.1-3 3.5-4.5 6.5-4.5s5.4 1.5 6.5 4.5M16 4.8a3.5 3.5 0 010 6.4M18 15.3c1.6.6 2.8 2 3.5 4.2"
      }
    ]
  ],
  "x": [
    [
      "path",
      {
        "d": "M6 6l12 12M18 6L6 18"
      }
    ]
  ]
};
